module.exports = __webpack_public_path__ + "media/images/marketplace_test-b07f9136d56bd62dea885cf032509b47.png";